import React from 'react'
import { DefaultDataTable } from '../../../components/dataTable/DefaultDataTable'

export const CrudDinamicoList = (props) => <DefaultDataTable data={props} />
